import React, { useContext } from "react";
import { Button, Col, Container, Input, Label, Row } from "reactstrap";
import { Border } from "../../../../constant";
import ImageBannerContext from "../../../context/ImageBannerContext/ImageBannerContext";
import ProductImageUploadPopup from "../../../Modals/imageUploade/productImageUploadPopup";
import { Switch } from "@material-ui/core";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { Cases, DELETE_CONFIRM } from "../../../constant";
import { delete_Multi_Image_Permanent } from "../apis/SliderApi/SliderApi";
import { Zoom, toast } from "react-toastify";
import Dividers from "../../../common/divider";
import { OpenModalCommonFunc } from "../../../utils";
import { UploadCloud } from "react-feather";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import CommonColor from "../../../common/CommonColor";
import CustomStyle from "../../../common/CustomStyle";
import ThemeImageShow from "../../../common/ThemeImageShow";
import ImageBannerTheme1 from "../ScreenShorts/ImageBanner/ImageBannerTheme1.png";
import ImageBannerTheme2 from "../ScreenShorts/ImageBanner/ImageBannerTheme2.png";

const SettingImagesBannerParentPopup = (props) => {
  const {
    isEdit,
    settingFormData,
    setSettingFormData,
    backImageToggle,
    setBackImageToggle,
    boxSection,
    setBoxSection,
    isBackgroundColor,
    setIsBackgroundColor,
    countOfList,
    imgShow,
    setImgShow,
    theme,
  } = useContext(ImageBannerContext);
  const {
    allPopupState,
    setAllPopupState,
    crop,
    setCrop,
    completedCrop,
    setCompletedCrop,
    scale,
    rotate,
  } = useContext(ByteCardBuilderContext);
  const { setLoaderShow } = useContext(LoaderContext);
  const { imageUpload, handleSubmitSetting } = props;

  /**
   * input value change
   * @param {event} e
   */

  const handleChangeCallActionSection = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [`.call-action-section${countOfList}`]: {
          ...prev[`.call-action-section${countOfList}`],
          [name]: value,
        },
      };
    });
  };

  const handleChangeCallActionSectionBtnPink = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [`.call-action-section${countOfList} .btn-pink`]: {
          ...prev[`.call-action-section${countOfList} .btn-pink`],
          [name]: value,
        },
      };
    });
  };
  const handleChangeCustomStyle = (e) => {
    const { value, name } = e.target;
    setSettingFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const resetHandler = () => {
    setSettingFormData((prev) => {
      return {
        ...prev,
        [`.call-action-section${countOfList}`]: {
          padding: "80px 0",
          "background-color": { r: 33, g: 37, b: 41, a: 100 },
        },
        [`.call-action-section${countOfList}.bg-image`]: {},
        [`.call-action-section${countOfList}.bg-image::before`]: {
          // "background-color": { r: 0, g: 0, b: 0, a: 0.8 },
        },
        [`.call-action-section${countOfList} .btn-pink`]: {
          "background-color": { r: 255, g: 73, b: 124, a: 100 },
          border: "2px solid { r: 255, g: 73, b: 124, a: 100 }",
          borderPx: "2px",
          borderThik: "solid",
          borderColor: { r: 255, g: 73, b: 124, a: 100 },
          color: { r: 255, g: 255, b: 255, a: 100 },
          padding: "8px 25px",
          p1: "8px",
          p2: "25px",
        },
        custom: "",
      };
    });
    setBackImageToggle(false);
    setBoxSection(false);
    setIsBackgroundColor(true);
  };

  /**
   * image reupload
   */
  const reupload = () => {
    setSettingFormData((prev) => {
      return {
        ...prev,
        image: "",
      };
    });
  };

  /**
   * delete image permanently
   */
  const deleteImagePermanent = async () => {
    try {
      let confirmation = window.confirm(DELETE_CONFIRM);
      if (confirmation) {
        setLoaderShow(true);
        let formData = {
          fileName: settingFormData?.[
            `.call-action-section${countOfList}.bg-image`
          ]?.["background-image"]
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop(),
        };
        const { data } = await delete_Multi_Image_Permanent(formData);
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
            position: "top-center",
          });
          setSettingFormData({
            ...settingFormData,
            [`.call-action-section${countOfList}.bg-image`]: {
              "background-image": "",
            },
          });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message, {
        autoClose: 1000,
        transition: Zoom,
      });
      setLoaderShow(false);
    }
  };

  const handleClose = () => {
    setImgShow(false);
  };
  const themeImg = {
    1: ImageBannerTheme1,
    2: ImageBannerTheme2,
  };
  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center position-relative">
              <div
                className="d-flex justify-content-between position-sticky"
                style={{ top: "87px", background: "white", zIndex: 999 }}
              >
                <h6>{isEdit ? "Edit" : "Add New"}</h6>
                <div className="d-flex gap-2">
                  <Button onClick={resetHandler}>Reset</Button>
                  <Button onClick={() => handleSubmitSetting(true)}>
                    Restore
                  </Button>
                  <Button
                    onClick={() => handleSubmitSetting(null, false)}
                    color="success"
                  >
                    Save & View
                  </Button>
                </div>
              </div>
              {!imgShow && (
                <div>
                  <Button
                    onClick={() => setImgShow(true)}
                    color="primary"
                    className="mt-2"
                  >
                    Show Theme Image
                  </Button>
                </div>
              )}
              {imgShow && (
                <ThemeImageShow
                  themeImg={themeImg[theme]}
                  handleClose={handleClose}
                />
              )}
              <Row className="mt-4">
                <h4 className="mb-3">Make change in Main section</h4>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Padding (Default : 80)"}
                  </Label>
                  <Input
                    className="form-control"
                    name="padding"
                    type="number"
                    placeholder="Padding"
                    value={settingFormData?.[
                      `.call-action-section${countOfList}`
                    ]?.["padding"]
                      ?.split(" ")[0]
                      ?.replace(/px/g, "")}
                    onChange={(e) => handleChangeCallActionSection(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>

                <Col md="4 mb-3">
                  <div className="d-flex align-items-center">
                    <Label htmlFor="validationCustom03">
                      {isBackgroundColor
                        ? "Add Background Color"
                        : "Remove Background Color"}
                    </Label>
                    <Switch
                      checked={isBackgroundColor}
                      inputProps={{ "aria-label": "controlled" }}
                      onChange={(e) => {
                        setIsBackgroundColor(e.target.checked);
                        setSettingFormData((prev) => {
                          if (e.target.checked) {
                            if (boxSection) {
                              return {
                                ...prev,
                                [`.call-action-section${countOfList}`]: {
                                  "background-color": "#000000",
                                  padding:
                                    settingFormData?.[
                                      `.call-action-section${countOfList}`
                                    ]?.["padding"],
                                  width: settingFormData?.[
                                    `.call-action-section${countOfList}`
                                  ]?.["width"]?.replace("rem)", ""),
                                  margin: settingFormData?.[
                                    `.call-action-section${countOfList}`
                                  ]?.["margin"]
                                    ?.split(" ")[0]
                                    ?.replace(/px/g, ""),
                                  "border-radius": settingFormData?.[
                                    `.call-action-section${countOfList}`
                                  ]?.["border-radius"]?.replace(/rem/g, ""),
                                },
                              };
                            } else {
                              return {
                                ...prev,
                                [`.call-action-section${countOfList}`]: {
                                  "background-color": "#000000",
                                  padding:
                                    settingFormData?.[
                                      `.call-action-section${countOfList}`
                                    ]?.["padding"],
                                },
                              };
                            }
                          } else {
                            if (boxSection) {
                              return {
                                ...prev,
                                [`.call-action-section${countOfList}`]: {
                                  padding:
                                    settingFormData?.[
                                      `.call-action-section${countOfList}`
                                    ]?.["padding"],
                                  width: settingFormData?.[
                                    `.call-action-section${countOfList}`
                                  ]?.["width"]?.replace("rem)", ""),
                                  margin: settingFormData?.[
                                    `.call-action-section${countOfList}`
                                  ]?.["margin"]
                                    ?.split(" ")[0]
                                    ?.replace(/px/g, ""),
                                  "border-radius": settingFormData?.[
                                    `.call-action-section${countOfList}`
                                  ]?.["border-radius"]?.replace(/rem/g, ""),
                                },
                              };
                            } else {
                              return {
                                ...prev,
                                [`.call-action-section${countOfList}`]: {
                                  padding:
                                    settingFormData?.[
                                      `.call-action-section${countOfList}`
                                    ]?.["padding"],
                                },
                              };
                            }
                          }
                        });
                      }}
                    />
                  </div>
                  {isBackgroundColor && (
                    <CommonColor
                      color={
                        settingFormData?.[
                          `.call-action-section${countOfList}`
                        ]?.["background-color"]
                      }
                      setSettingFormData={setSettingFormData}
                      className={`.call-action-section${countOfList}`}
                      classProperty={"background-color"}
                      label={"Select Background Color"}
                    />
                  )}
                </Col>
                <p>{"Box Section : convert your section to Box section"}</p>
                <div>
                  <Switch
                    checked={boxSection}
                    inputProps={{ "aria-label": "controlled" }}
                    onChange={(e) => {
                      setBoxSection(e.target.checked);
                      setSettingFormData((prev) => {
                        return {
                          ...prev,
                          [`.call-action-section${countOfList}`]: {
                            padding: settingFormData?.[
                              `.call-action-section${countOfList}`
                            ]?.["padding"]
                              ?.split(" ")[0]
                              ?.replace(/px/g, ""),
                            "background-color":
                              settingFormData?.[
                                `.call-action-section${countOfList}`
                              ]?.["background-color"],
                            width: e.target.checked ? "10" : "",
                            margin: e.target.checked ? "0" : "",
                            "border-radius": e.target.checked ? "3" : "",
                          },
                        };
                      });
                    }}
                  />
                </div>
                {boxSection && (
                  <>
                    <Col md="4 mb-3">
                      <Label htmlFor="validationCustom03">
                        {"Width (Default : 10)"}
                      </Label>
                      <Input
                        className="form-control"
                        name="width"
                        type="number"
                        placeholder="width"
                        value={settingFormData?.[
                          `.call-action-section${countOfList}`
                        ]?.["width"]?.replace("rem)", "")}
                        onChange={(e) => handleChangeCallActionSection(e)}
                        style={{ borderRadius: "0", color: "black" }}
                      />
                    </Col>
                    <Col md="4 mb-3">
                      <Label htmlFor="validationCustom03">
                        {"Margin (Default : 0)"}
                      </Label>
                      <Input
                        className="form-control"
                        name="margin"
                        type="number"
                        placeholder="margin"
                        value={settingFormData?.[
                          `.call-action-section${countOfList}`
                        ]?.["margin"]
                          ?.split(" ")[0]
                          ?.replace(/px/g, "")}
                        onChange={(e) => handleChangeCallActionSection(e)}
                        style={{ borderRadius: "0", color: "black" }}
                      />
                    </Col>
                    <Col md="4 mb-3">
                      <Label htmlFor="validationCustom03">
                        {"Border Radius (Default : 3)"}
                      </Label>
                      <Input
                        className="form-control"
                        name="border-radius"
                        type="number"
                        placeholder="Border Radius"
                        value={settingFormData?.[
                          `.call-action-section${countOfList}`
                        ]?.["border-radius"]?.replace(/rem/g, "")}
                        onChange={(e) => handleChangeCallActionSection(e)}
                        style={{ borderRadius: "0", color: "black" }}
                      />
                    </Col>
                  </>
                )}
              </Row>

              <hr />
              <Row className="mt-4">
                <Col md="12 mb-3">
                  <h4 className="mb-3">Add Background Image in section</h4>

                  <p>do you want to upload Background image</p>
                  <Switch
                    checked={backImageToggle}
                    inputProps={{ "aria-label": "controlled" }}
                    onChange={(e) => {
                      setBackImageToggle(e.target.checked);
                      setSettingFormData((prev) => {
                        return {
                          ...settingFormData,
                          image: "",
                          [`.call-action-section${countOfList}.bg-image`]: {
                            "background-image": "",
                          },
                          [`.call-action-section${countOfList}.bg-image::before`]:
                            {
                              "background-color": "",
                              // "background-color": { r: 0, g: 0, b: 0, a: 0.8 },
                            },
                        };
                      });
                    }}
                  />
                  {backImageToggle && (
                    <>
                      {" "}
                      <Col md="6 mb-3">
                        <Dividers divide="IMAGE" />
                        <p className="mb-4">
                          File type required JPG, PNG (1905 X 228px)
                        </p>
                      </Col>
                      <Row>
                        <Col md="4 mb-3">
                          <div
                            className="aj-uploader d-flex flex-wrap  justify-content-center  align-items-center"
                            style={{ cursor: "pointer" }}
                          >
                            {!settingFormData?.[
                              `.call-action-section${countOfList}.bg-image`
                            ]?.["background-image"] && (
                              <span
                                onClick={() =>
                                  OpenModalCommonFunc(
                                    Cases.PRODUCT_UPLOAD,
                                    setAllPopupState
                                  )
                                }
                              >
                                <UploadCloud />
                              </span>
                            )}

                            {settingFormData?.[
                              `.call-action-section${countOfList}.bg-image`
                            ]?.["background-image"] && (
                              <img
                                src={
                                  settingFormData?.[
                                    `.call-action-section${countOfList}.bg-image`
                                  ]?.["background-image"] || ""
                                }
                                alt=""
                                style={{
                                  width: "85%",
                                  height: "90px",
                                  objectFit: "contain",
                                  position: "absolute",
                                }}
                                onClick={() => deleteImagePermanent()}
                              />
                            )}
                            {settingFormData?.[
                              `.call-action-section${countOfList}.bg-image`
                            ]?.["background-image"] && (
                              <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="close"
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  top: "-22px",
                                  left: "1px",
                                }}
                                onClick={() => deleteImagePermanent()}
                              >
                                <Close
                                  style={{
                                    fontSize: "25px",
                                    fontWeight: "bold",
                                  }}
                                />
                              </IconButton>
                            )}
                          </div>
                        </Col>
                        <Col md="6 mb-3">
                          <h4 className="mb-3">
                            Add Background color in section
                          </h4>
                          <Col md="6 mb-3">
                            <CommonColor
                              color={
                                settingFormData?.[
                                  `.call-action-section${countOfList}.bg-image::before`
                                ]?.["background-color"]
                              }
                              setSettingFormData={setSettingFormData}
                              className={`.call-action-section${countOfList}.bg-image::before`}
                              classProperty={"background-color"}
                              label={"Select Background Color"}
                            />
                            {/* <Input
                              className="form-control"
                              name="background-color"
                              type="color"
                              placeholder="Background Color"
                              value={
                                settingFormData?.[
                                  ".call-action-section.bg-image::before"
                                ]?.["background-color"]
                              }
                              onChange={(e) =>
                                handleChangCallActionSectionBgImage(e)
                              }
                              style={{ borderRadius: "0", color: "black" }}
                            /> */}
                          </Col>
                        </Col>
                      </Row>
                    </>
                  )}
                </Col>
              </Row>
              <hr />
              <Row className="mt-4">
                <h4 className="mb-3">Make change in section button</h4>
                <Col md="4 mb-3">
                  <CommonColor
                    color={
                      settingFormData?.[
                        `.call-action-section${countOfList} .btn-pink`
                      ]?.["background-color"]
                    }
                    setSettingFormData={setSettingFormData}
                    className={`.call-action-section${countOfList} .btn-pink`}
                    classProperty={"background-color"}
                    label={"Select Background Color"}
                  />
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Border (Default : 2 solid pink)"}
                  </Label>
                  <div className="d-flex">
                    <div style={{ width: "100px" }}>
                      <Input
                        className="form-control"
                        name="borderPx"
                        type="number"
                        placeholder="px"
                        value={settingFormData?.[
                          `.call-action-section${countOfList} .btn-pink`
                        ]?.["borderPx"]?.replace(/px/g, "")}
                        onChange={(e) =>
                          handleChangeCallActionSectionBtnPink(e)
                        }
                        style={{ borderRadius: "0", color: "black" }}
                      />
                    </div>
                    <div style={{ width: "100px" }}>
                      <select
                        name="borderThik"
                        id="borderThik"
                        className="form-control"
                        value={
                          settingFormData?.[
                            `.call-action-section${countOfList} .btn-pink`
                          ]?.["borderThik"]
                        }
                        onChange={(e) =>
                          handleChangeCallActionSectionBtnPink(e)
                        }
                        style={{ borderRadius: "0", color: "black" }}
                      >
                        <option value="">--select--</option>
                        {Border.map((elem) => {
                          return (
                            <option value={elem.border}>{elem.border}</option>
                          );
                        })}
                      </select>
                    </div>
                    <div>
                      <CommonColor
                        color={
                          settingFormData?.[
                            `.call-action-section${countOfList} .btn-pink`
                          ]?.["borderColor"]
                        }
                        setSettingFormData={setSettingFormData}
                        className={`.call-action-section${countOfList} .btn-pink`}
                        classProperty={"borderColor"}
                        label={"Select Color"}
                      />
                    </div>
                  </div>
                </Col>
                <Col md="4 mb-3">
                  <CommonColor
                    color={
                      settingFormData?.[
                        `.call-action-section${countOfList} .btn-pink`
                      ]?.["color"]
                    }
                    setSettingFormData={setSettingFormData}
                    className={`.call-action-section${countOfList} .btn-pink`}
                    classProperty={"color"}
                    label={"Select Color"}
                  />
                </Col>
                <Col md="4 mb-3">
                  <Label htmlFor="validationCustom03">
                    {"Padding (Default : 8 - 25)"}
                  </Label>
                  <div className="d-flex justify-content-between">
                    <Input
                      className="form-control"
                      name="p1"
                      type="number"
                      placeholder="Padding"
                      value={settingFormData?.[
                        `.call-action-section${countOfList} .btn-pink`
                      ]?.["p1"]?.replace(/px/g, "")}
                      onChange={(e) => handleChangeCallActionSectionBtnPink(e)}
                      style={{ borderRadius: "0", color: "black" }}
                    />
                    <Input
                      className="form-control"
                      name="p2"
                      type="number"
                      placeholder="Padding"
                      value={settingFormData?.[
                        `.call-action-section${countOfList} .btn-pink`
                      ]?.["p2"]?.replace(/px/g, "")}
                      onChange={(e) => handleChangeCallActionSectionBtnPink(e)}
                      style={{ borderRadius: "0", color: "black" }}
                    />
                  </div>
                </Col>
              </Row>
              <CustomStyle
                handleChange={handleChangeCustomStyle}
                value={settingFormData?.custom}
              />
            </div>
          </Col>
        </Row>
        <ProductImageUploadPopup
          allPopupState={allPopupState}
          setAllPopupState={setAllPopupState}
          crop={crop}
          setCrop={setCrop}
          completedCrop={completedCrop}
          setCompletedCrop={setCompletedCrop}
          scale={scale}
          rotate={rotate}
          image={settingFormData?.image}
          setImage={setSettingFormData}
          imageUpload={imageUpload}
          isEdit={isEdit}
          reupload={reupload}
          // aspect={8.36 / 1}
        />
      </Container>
    </>
  );
};

export default SettingImagesBannerParentPopup;
